<template>
    <div class="flex flex-col gap-y-4">
        <form-element title="Vote in a Poll">
            <donation-select v-model="poll" :disabled="!polls.length">
                <template #label>
                    {{ poll ? poll.query : polls.length ? 'Select...' : 'No polls' }}
                </template>

                <select-option
                    v-for="poll in polls"
                    :key="poll.id"
                    :value="poll"
                >
                    {{ poll.query }}
                </select-option>
            </donation-select>

            <template #accessory>
                <button v-if="poll" class="text-cool-gray flex items-center gap-x-1 text-sm" @click="clear()">
                    <CloseRectangleFillIcon class="-mt-0.5" />
                    <span>Clear Selection</span>
                </button>
            </template>
        </form-element>

        <RadioGroup v-if="poll" v-model="item" class="flex flex-col space-y-2 text-lg">
            <RadioGroupLabel class="sr-only">Items for poll "{{ poll.query }}"</RadioGroupLabel>
            <RadioGroupOption
                v-slot="{ checked }"
                v-for="item in poll.items"
                :key="item.id"
                :value="item"
                class="flex space-x-2"
            >
                <span class="flex w-6 h-6 bg-gradient-to-br from-purple to-blue rounded-full items-center justify-center">
                    <span class="block rounded-full w-5 h-5" :class="[
                        checked ? 'border-4 border-dark-blue' : 'bg-dark-blue'
                    ]"></span>
                </span>
                <span class="text-white">{{ item.answer }} - <span class="text-light-green">{{ formatMoney(item.total) }}</span></span>
            </RadioGroupOption>
        </RadioGroup>
    </div>
</template>

<script setup>
import { ref, inject, onMounted } from 'vue';
import {
    RadioGroup,
    RadioGroupLabel,
    RadioGroupOption,
} from '@headlessui/vue';
import { formatMoney } from '../../utils';
import DonationSelect from './ui/Select.vue';
import SelectOption from './ui/SelectOption.vue';
import FormElement from './ui/FormElement.vue';
import CloseRectangleFillIcon from './icons/CloseRectangleFillIcon.vue';

const polls = ref([]);
const poll = inject('poll');
const item = inject('pollItem');

onMounted(() => {
    fetch('/polls')
        .then(response => response.json())
        .then(value => {
            polls.value = value;
        })
})

const clear = () => {
    poll.value = null;
    item.value = null;
}
</script>